const items = [
    {
        "type": "satellite_grouping_player",
        "locations": ["Iraí", "Passaúna", "Piraquara I e II"],
        "satellites": [
            {
                name: "NDTI S2",
                title: "Turbidez",
                description:
                    "Turbidez (Sentinel-2).",
            },
            {
                name: "NDCI S2",
                title: "Clorofila",
                description:
                    "Clorofila (Sentinel-2).",
            },
            {
                name: "MACR S1",
                title: "Macrófitas",
                description:
                    "Macrófitas (Sentinel-1).",
            },
        ],
    }
];

export default items;